import { render, staticRenderFns } from "./RoleLista.vue?vue&type=template&id=07f12050&lang=html"
import script from "./RoleLista.vue?vue&type=script&lang=js"
export * from "./RoleLista.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports